function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function normalizeSearchTerm(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function normalizeAthleteClientId(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function resolveClientAthleteDisplayName(client) {
  const coachFacingParts = [client?.nameForCoach, client?.surnameForCoach]
    .filter(hasText)
    .map((value) => String(value).trim());

  if (coachFacingParts.length > 0) {
    return coachFacingParts.join(" ");
  }

  const fallbackParts = [client?.name, client?.surname]
    .filter(hasText)
    .map((value) => String(value).trim());

  return fallbackParts.join(" ");
}

export function sortAthletesByDisplayName(clients = []) {
  return [...(Array.isArray(clients) ? clients : [])].sort((left, right) =>
    resolveClientAthleteDisplayName(left).localeCompare(
      resolveClientAthleteDisplayName(right),
      undefined,
      { sensitivity: "base" },
    ),
  );
}

export function buildClientNutritionCopyAthleteResults(
  clients,
  searchText = "",
  currentClientId = null,
) {
  const normalizedSearch = normalizeSearchTerm(searchText);
  const normalizedCurrentClientId = normalizeAthleteClientId(currentClientId);

  return sortAthletesByDisplayName(clients).filter((client) => {
    const normalizedClientId = normalizeAthleteClientId(client?.id);
    if (normalizedClientId && normalizedClientId === normalizedCurrentClientId) {
      return false;
    }

    if (!normalizedSearch) {
      return true;
    }

    return resolveClientAthleteDisplayName(client)
      .toLowerCase()
      .includes(normalizedSearch);
  });
}
